/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    parts: [
        'container',
        'content',
        'inputGroup',
        'subscribe',
        'subscribeField',
        'subscribeButtonContainer',
        'subscribeHeading',
        'subscribeMessage',
        'bottomHalf',
        'horizontalRule',
        'linkList',
        'copyright',
        'socialIcons'
    ],
    baseStyle: {
        container: {
            width: 'full',
            background: 'black',
            position: 'relative'
        },
        content: {
            maxWidth: 'container.xxl',
            marginLeft: 'auto',
            marginRight: 'auto',
            color: 'white',
            paddingTop: {base: 10, md: 20},
            paddingBottom: 16,
            paddingLeft: {base: 8, xl: 0},
            paddingRight: {base: 8, xl: 0}
        },
        inputGroup: {
            flexDirection: ['column-reverse', 'initial']
        },
        subscribe: {
            maxWidth: {base: '21.5rem', sm: '32.5rem', lg: 'none'}
        },
        subscribeField: {
            width: ['100%', '62%', '62%', '66%'],
            padding: 0,
            background: 'black',
            color: 'gray.200',
            textStyle: 'bookLarge',
            border: 'none',
            borderRadius: 0,
            borderBottom: '1px solid',
            borderColor: 'gray.200'
        },
        subscribeButtonContainer: {
            width: 'auto',
            position: ['static', 'absolute'],
            justifyContent: ['flex-start', 'center'],
            marginTop: ['1.5rem', 0],
            top: {sm: '-8px'}
        },
        subscribeHeading: {
            marginBottom: 3
        },
        subscribeMessage: {
            fontSize: 'sm',
            marginBottom: 4
        },
        bottomHalf: {
            maxWidth: {base: '34.5rem', lg: '100%'}
        },
        horizontalRule: {
            marginTop: 4,
            marginBottom: 4
        },
        linkList: {
            fontSize: '20px !important'
        },
        copyright: {
            fontSize: 'sm',
            marginBottom: 6,
            color: 'gray.50'
        },
        socialIcons: {
            marginTop: 4
        }
    }
}
